/**
 * Klok in de statusregel (eigenaar 30-10-2026: "kan je in de admin de tijd
 * aangeven", variant B). De beheerconsole toont alle tijden in de tijdzone
 * van het apparaat; de server bewaart ze in UTC. Staat het apparaat niet op
 * Nederlandse tijd, dan kleurt de klok rood.
 */

export const NL_ZONE = 'Europe/Amsterdam';

export interface Klok {
  /** "Fri 30 Oct 10:12:00" */
  tijd: string;
  /** "Europe/Amsterdam UTC+1" */
  zone: string;
  /** Apparaat staat niet op Nederlandse tijd. */
  anders: boolean;
  /** Tooltip met uitleg (en de Nederlandse tijd als die afwijkt). */
  titel: string;
}

/** De tijdzone van dit apparaat, zoals de browser hem gebruikt. */
export function apparaatZone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  } catch {
    return 'UTC';
  }
}

/** "UTC+1", "UTC+5:30" of "UTC". */
export function zoneOffset(nu: Date, zone: string): string {
  const deel = new Intl.DateTimeFormat('en-GB', { timeZone: zone, timeZoneName: 'shortOffset' })
    .formatToParts(nu)
    .find((d) => d.type === 'timeZoneName')?.value ?? 'GMT';
  return deel.replace('GMT', 'UTC');
}

function uur(nu: Date, zone: string, seconden: boolean): string {
  return new Intl.DateTimeFormat('en-GB', {
    timeZone: zone, hour: '2-digit', minute: '2-digit', ...(seconden ? { second: '2-digit' } : {}), hourCycle: 'h23',
  }).format(nu);
}

export function klok(nu: Date, zone: string = apparaatZone()): Klok {
  // "Fri 30 Oct"; Chrome zet er een komma achter de dag, Node niet.
  const dag = new Intl.DateTimeFormat('en-GB', { timeZone: zone, weekday: 'short', day: 'numeric', month: 'short' }).format(nu).replace(',', '');
  const offset = zoneOffset(nu, zone);
  const anders = zone !== NL_ZONE;
  return {
    tijd: `${dag} ${uur(nu, zone, true)}`,
    zone: `${zone} ${offset}`,
    anders,
    titel: anders
      ? `Times in this console follow this device's time zone: ${zone} (${offset}). Dutch time now: ${uur(nu, NL_ZONE, false)} (${zoneOffset(nu, NL_ZONE)}).`
      : `Times in this console are Dutch time: ${zone} (${offset}).`,
  };
}
